module.exports = __webpack_public_path__ + "static/media/Investor-BRETT DIBKEY_1646328720606.9c9375ef.vtt";